import React from "react";
import style from "./header.module.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { configAction } from "../../store/config/slice";
import { GameStep } from "../../types/config";
import useWebEngageMyGiftClick from "../../hooks/webengage/useWebEngageMyGiftClick";
interface Iprop {
  chance?: boolean;
  title?: string;
  onBack?: () => void;
  disableBtn?: boolean;
  result?: boolean;
  logo?: boolean;
  className?: string;
  home?: boolean;
}
const Header: React.FC<Iprop> = ({
  chance,
  title,
  onBack,
  disableBtn,
  result,
  logo,
  className,
  home,
}) => {
  const dispatch = useAppDispatch();

  const userChance = useAppSelector((state) => state.game.chnace);
  const userSpecialChance = useAppSelector(
    (state) => state.game.special_chance
  );
  const { trackWebEngageMyGiftClick } = useWebEngageMyGiftClick();
  const handleBanibonPage = function () {
    dispatch(configAction.setGameStep(GameStep.BANIBON));
    trackWebEngageMyGiftClick();
  };
  return (
    <header className={`${style.header} ${className ? className : ""}`}>
      {!logo ? (
        <div className={style.inner}>
          {!result ? (
            <button
              className={style.back}
              onClick={onBack}
              disabled={disableBtn}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/arrow-right.svg`}
                alt=""
                className={!disableBtn ? "hover" : ""}
              />
              <div className={`${style.title} desktop`}>
                <span> {title}</span>
              </div>
            </button>
          ) : (
            <>
              <div className={style.result} onClick={handleBanibonPage}>
                <span>جوایز من</span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/icon/gift.svg`}
                  alt="banilogo"
                  className="desktop"
                />
              </div>
            </>
          )}
          <div className={`${style.title} mobile`}>
            <span> {title}</span>
          </div>
          <nav className={` desktop`}>
            <a
              href="https://www.banimode.com/"
              target="_blank"
              rel="noreferrer"
              className={style.logo}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/banilogo.svg`}
                alt="banilogo"
              />
              <span>مرکـــز خرید آنلاین بانی‌مد</span>
            </a>
          </nav>
          {chance ? (
            <div className={style.chnace}>
              <span>شانس:</span>
              <img
                src={`${process.env.PUBLIC_URL}/assets/icon/red-heart.svg`}
                alt=""
              />
              <span>{userChance}</span>
              <img
                style={{ marginRight: 4 }}
                src={`${process.env.PUBLIC_URL}/assets/icon/gold-heart.svg`}
                alt=""
              />
              <span>{userSpecialChance}</span>
            </div>
          ) : (
            <div className={style.holder}></div>
          )}
        </div>
      ) : (
        <nav className={style.nav}>
          <a
            href="https://www.banimode.com/"
            target="_blank"
            rel="noreferrer"
            className={style.logo}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/icon/banilogo.svg`}
              alt="banilogo"
            />
            <span>مرکـــز خرید آنلاین بانی‌مد</span>
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;
